import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '@core';

@Component({
  selector: 'app-translate',
  template: `
      <ng-container *ngIf="(langs | keyvalue).length > 1">
          <button mat-icon-button class="matero-toolbar-button" [matMenuTriggerFor]="menu">
              <mat-icon>translate</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
              <button mat-menu-item *ngFor="let lang of langs | keyvalue" (click)="useLanguage(lang.key)">
                  <span>{{ lang.value }}</span>
              </button>
          </mat-menu>
      </ng-container>
  `,
  styles: [],
})
export class TranslateComponent {
  public langs = {
    'de': 'Deutsch',
    // 'en-US': 'English',
  };

  constructor(private translate: TranslateService, private settings: SettingsService) {
    const keys = Object.keys(this.langs);

    if (keys.length === 1) {
      keys.forEach(value => this.useLanguage(value));
    }

    translate.addLangs(keys);
  }

  useLanguage(language: string) {
    this.translate.use(language);
    this.settings.setLanguage(language);
  }
}
